
export const LAYOUTS = {
  NOT_SIGNED_IN: 'notsignedin-layout',
  USER: 'user-layout',
  PROVIDER: 'provider-layout',
  ADMIN: 'admin-layout',
}
